<form *ngIf="zoneFormGroup" [formGroup]="zoneFormGroup">
    <p-card class="p-3" header="Datos generales">
        <div class="grid">
            <div class="col-4 input-field">
                <label for="name">Nombre *</label>
                <input pInputText formControlName="name" id="name" d-form-field-error />
            </div>
            <div class="col-3 input-field">
                <label for="name">País *</label>
                <p-dropdown [options]="countries" formControlName="countryId" optionValue="id"
                    [filter]="true" filterBy="name" optionLabel="name" placeholder="Seleccione pais"
                    (onChange)="onCountryChange($event)"
                    d-form-field-error showClear />
            </div>
            <div class="col-3 input-field">
                <label for="name">Provincia *</label>
                <p-dropdown [options]="countriesRegions" formControlName="countryRegionId" optionValue="id"
                    [filter]="true" filterBy="name" optionLabel="name" placeholder="Seleccione provincia"
                    d-form-field-error showClear />
            </div>
            <div class="col-2 input-field">
                <label for="active">Activo</label>
                <p-inputSwitch id="active" formControlName="active"></p-inputSwitch>
            </div>
        </div>

        <div class="mt-4 flex gap-2 justify-content-end">
            <p-button label="Eliminar" *ngIf="allowDelete && zone.id" icon="pi pi-trash" styleClass="p-button-danger"
                (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>
    </p-card>

    <p-tabView *ngIf="zone.id">
        <p-tabPanel header="Zonas">
            <div class="flex justify-content-end mb-2">
                <p-button label="Cargar Excel" (click)="loadExcel()" icon="pi pi-upload" styleClass="p-button-secondary p-button-sm mr-1"
                    *ngIf="allowWrite"></p-button>
                <p-button label="Descargar Excel" (click)="downloadExcel()" icon="pi pi-download"
                    styleClass="p-button-secondary p-button-sm mr-1" *ngIf="allowWrite"></p-button>
                <p-button *ngIf="allowWrite" label="Añadir línea de zona" icon="pi pi-plus"
                    (click)="editZoneLine(null)" />
            </div>
            <p-table #grid [value]="zoneLines" [scrollable]="true" scrollHeight="flex"
                [lazy]="true" (onLazyLoad)="loadZoneLines($event)" [loading]="loadingZoneLines"
                [paginator]="true" [rows]="1000" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[1000]"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            >
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="value">Valor <p-sortIcon field="value"></p-sortIcon>
                        </th>
                        <th width=" 100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-zoneLine let-columns="columns">
                    <tr (dblclick)="editZoneLine(zoneLine)">
                        <td>
                            {{zoneLine.value}}
                        </td>
                        <td>
                            <div class="flex gap-2 justify-content-end">
                                <p-button *ngIf="allowDelete" (click)="deleteZoneLine(zoneLine.id)" [rounded]="true"
                                    [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                                <p-button *ngIf="allowWrite" (click)="editZoneLine(zoneLine)" [rounded]="true"
                                    [text]="false"><i class="pi pi-pencil"></i></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
            <span *ngIf="zoneLines.length == 0">
                No se han encontrado líneas de zona
            </span>

        </p-tabPanel>
    </p-tabView>
</form>
<p-confirmDialog></p-confirmDialog>